export const studentConstants = {
  GET_PAGINATION_DATA: "GET_PAGINATION_DATA",
  ADD_STUDENT: "ADD_STUDENT",
  VIEW_STUDENT: "VIEW_STUDENT",
  GET_STATS: "GET_STATS",
  INITIAL_STATE: "INITIAL_STATE",
  GET_CENTER_PAGINATION_DATA: "GET_CENTER_PAGINATION_DATA",
  GET_ALL_COURSES: "GET_ALL_COURSES",
  GET_COURSES_BY_SYSTEM_ID: "GET_COURSES_BY_SYSTEM_ID",
  GET_ALL_QUESTIONS: "GET_ALL_QUESTIONS",
  GET_FEEDBACK_BY_ID: "GET_FEEDBACK_BY_ID",
};

export const studentType =  {
  VERIFIED_STUDENT: 0,
  NON_VERIFIED_STUDENT: 1,
}